import { axios } from '~/libs/axios';
import { type TAdmin, type TUserStats } from '~/types';

const getMe = async (): Promise<TAdmin | null> => {
  const { data } = await axios.get<TAdmin | null>('/admin/me');
  return data;
};

const getUserStats = async (days: number): Promise<TUserStats> => {
  const { data } = await axios.get<TUserStats>('/admin/users/stats', {
    params: { days },
  });
  return data;
};

export const adminAPI = {
  getMe,
  getUserStats,
};
